import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {
    PERMISSION_TALENTS_READ,
    PERMISSION_VACANCIES_CONTRACTS_MANAGE
  } from '../../../constants'
import {checkPermission} from '../../common/functions/permissions'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import {clearVacancyContracts, fetchVacancyContractsSuccess} from '../../../actions/pages/vacancy-page'
import Table from '../../../tables/reactable/DefaultTable'
import StatusBadge from '../../common/helpers/StatusBadge'
import ProtectedElement from '../../common/helpers/ProtectedElement'

class ContractsList extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.resendContract = this.resendContract.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.state = {
      itemsPerPage: 10,
      search: '',
      filter: {
        Status: ''
      }
    }
  }

  componentDidMount() {
    this.setState({
        columns: [
        'AvatarImage',
        'FullName',
        'FullNameForSearch',
        'FileName',
        'Revision',
        'SentDate',
        'AcceptedDate',
        'Status',
        'Actions'
      ],
      columnNames: [
        '',
        'Full name',
        'FullNameForSearch',
        'Document',
        'Revision',
        'Sent on',
        'Accepted on',
        'Status',
        'Actions'
      ]
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.contracts === null){
      this.fetchContracts();
    }
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  resendContract(contract) {
    let url = 'vacancies/' + this.props.vacancyId + '/contracts/' + contract.Id + '/resend'
    this.props.ajax.put(url, null, null, () => {
      this.props.clearVacancyContracts();
      this.props.notify('The contract was resent.');
    })
  }

  fetchContracts() {
    let url = 'vacancies/' + this.props.vacancyId + '/contracts'

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        data[index].NavigationParam = data[index].SkillVendorId;
      });
      this.props.fetchVacancyContractsSuccess(data);
    });
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }

  render() {
    if (this.props.contracts === null) {
      return (<div />)
    }

    let items = this.props.contracts.map(item => {
      return Object.assign({}, item, {
        Status: (<StatusBadge status={item.Status.toLowerCase()} statusLabel={item.StatusLabel} />),
        AvatarImage: item.AvatarImageUrl ? (<img src={item.AvatarImageUrl} style={{ width: '50px' }} className="rounded-circle" alt="" />) : (null),
        FileName: item.FileName ? (<a href={item.FileUrl}>{item.FileName}</a>) : (null),
        FullNameForSearch: item.FullName,
        AcceptedDate: item.AcceptedDate ? (<span>{item.AcceptedDateAsString}</span>) : (null),
        SentDate: item.SentDate ? (<span>{item.SentDateAsString}</span>) : (null),
        FullName: checkPermission(PERMISSION_TALENTS_READ)
          ? (<a href={'/talents/' + item.SkillVendorId + '/overview'}>{item.FullName}</a>)
          : (<span>{item.FullName}</span>),
        Actions:
        (
          <React.Fragment>
            {item.Status !== 'Accepted' ?
              <span>
                <ProtectedElement permission={PERMISSION_VACANCIES_CONTRACTS_MANAGE}>
                    <button
                      className="btn btn-primary btn-rounded"
                      type="button"
                      style={{marginRight:10}}
                      onClick={(e) => this.resendContract(item)}>
                      Resend
                    </button>
                </ProtectedElement>
                </span>
            :''}
          </React.Fragment>
        )
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.state.columns}
          columnNames={this.state.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          hiddenColumns={['FullNameForSearch']}
          searchable={['FullNameForSearch']}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[{
            column: 'Status',
            filters: [
              {
                value: 'pending',
                label: 'Pending'
              },
              {
                value: 'accepted',
                label: 'Accepted'
              },
              {
                value: 'cancelled',
                label: 'Cancelled'
              }
            ]
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={false}
          sortable={[
            {
                column: 'SentDate',
                sortFunction: function(a, b) {
                  return a.props ? a.props.children.localeCompare(b.props.children): 0;
                }
            }
          ]}
          defaultSort={{column: 'SentDate', direction: 'desc'}}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  contracts: state.vacancyPage.contracts
})
const mapDispatchToProps = dispatch => ({
  clearVacancyContracts() { dispatch(clearVacancyContracts()) },
  fetchVacancyContractsSuccess(contracts) { dispatch(fetchVacancyContractsSuccess(contracts)) }
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(ContractsList)
